export default __webpack_public_path__ + "static/media/mlbFantasyPWRSmobile.96a34295.png";